import { Select } from "antd";
import {
  findLevelsByIdStudent
} from "api/services/levels/levels.services";
import { getAvancement } from "api/services/quizz/quizz.services";
import * as appRoutes from "config/routes.config";
import React, { useCallback, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import * as TOPICS_SERVICES from "../../../api/services/topics/topics.services";

import { StatusCode, TypeMatiers } from "common/enums";
import { useDispatch, useSelector } from "react-redux";
import { useGetAllLevelsQuery } from "store/services/app/levels.services";

//!COMPONENTS
import Breadcrumbs from "components/breadcrumbs";
import AppScreen from "screens/teacher/ScreenWithSidebar";
import CardTracked from "../components/cardTracked";

//IMAGES
import { ReactComponent as Arrow } from "../../../assets/images/app/arrow.svg";
import Dashboard from "../../../assets/images/app/dashboard.svg";
import ANGLAIS from "../../../assets/images/app/iconMatiers/Anglais.png";
import FRANCAIS from "../../../assets/images/app/iconMatiers/Francais.png";
import HISTOIREGEO from "../../../assets/images/app/iconMatiers/Histoire-geo.png";
import MATH from "../../../assets/images/app/iconMatiers/Mathematiques.png";
import PHILO from "../../../assets/images/app/iconMatiers/Philosophie.png";
import PHYSIQUE from "../../../assets/images/app/iconMatiers/Physique-chimie.png";
import SVT from "../../../assets/images/app/iconMatiers/SVT.png";
import CoachAlbert from "../../../assets/images/app/new_albert_ai.svg";
import Ressources from "../../../assets/images/app/new_ressources.svg";

//!STYLES
import AppResult from "components/appResults";
import { setOpenAIDrawer } from "store/app/appSlice";
import Stats from "../stats";
import s from "./assets/dashboard.module.css";

const { Option, OptGroup } = Select;
const defaultLevel = "62e00770bbf0e80cf966552d";

const StudentDashboard = () => {
  const { data: levelsData, isLoading, isError } = useGetAllLevelsQuery();
  const levels = useSelector((state) => state.levels);
  const { user, isLoggedIn, isAppInMaintenance } = useSelector((state) => state.auth);
  const [progress, setProgress] = useState<any>([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [tempTopic, setTempTopic] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [tempLevelId, setTempLevelId] = useState<any | null>("");
  const [currentTab, setCurrentTab] = useState<number>(2);

  // FIX 1: Move resize listener into useEffect with proper cleanup
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 767);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize); // cleanup
  }, []);

  const OnSelectLevel = useCallback(
    async (levelId: string | any) => {
      setLoading(true);
      const response = await TOPICS_SERVICES.findAll(levelId);
      if (response?.statusCode === StatusCode.OK) {
        setTempTopic(response?.data);
        getProgression(user?._id, levelId);
        setLoading(false);
      }
    },
    [tempTopic]
  );

  const onFetchLevel = async (idLvel: string | any) => {
    try {
      const response = await findLevelsByIdStudent(idLvel);
      setTempLevelId(response.data);
      return response.data;
    } catch (error) { }
  };

  const getProgression = useCallback(
    async (id: string | any, level: string | any) => {
      if (user) {
        const response = await getAvancement(id, level);
        if (response?.statusCode === StatusCode.OK) {
          setProgress(response?.data);
        }
      }
    },
    []
  );

  useEffect(() => {
    let idLevel: any = localStorage.getItem("tempLevelId");
    if (idLevel === "" || idLevel === null || idLevel === "null") {
      if (user?.levelId !== undefined) {
        idLevel = user?.levelId;
      } else {
        idLevel = "62e00770bbf0e80cf966552d";
      }
      localStorage.setItem("tempLevelId", idLevel);
    }
    OnSelectLevel(idLevel || user?.levelId || defaultLevel);
    onFetchLevel(idLevel);
    setTempLevelId(idLevel);
  }, [isLoading]);

  useEffect(() => {
    if (isAppInMaintenance) {
      navigate(appRoutes.MAINTENANCE);
    }
  }, [isAppInMaintenance]);

  const allLevels = levelsData?.data;

  const getIcon = (description: string) => {
    const map: Record<string, string> = {
      [TypeMatiers.mathematique]: MATH,
      [TypeMatiers.SVT]: SVT,
      [TypeMatiers.PhysiqueChimie]: PHYSIQUE,
      [TypeMatiers.Philosophie]: PHILO,
      [TypeMatiers.HistoireGeo]: HISTOIREGEO,
      [TypeMatiers.Francais]: FRANCAIS,
      [TypeMatiers.Anglais]: ANGLAIS,
    };
    return map[description] || "";
  };

  return (
    <React.Fragment>
      {!isMobile && <Breadcrumbs isMycontent={true} />}
      <AppScreen>
        <div className={s.dahboard}>
          {isLoggedIn && (
            <div className={s.menuTabs}>
              <div
                onClick={() => dispatch(setOpenAIDrawer(true))}
                className={`${s.menuBox} ${currentTab === 1 ? s.menuBoxActive : ""}`}
              >
                <img src={CoachAlbert} height={isMobile ? 45 : 65} style={{ marginRight: "10px" }} />
                Coach Albert
              </div>
              <div
                onClick={() => setCurrentTab(2)}
                className={`${s.menuBox} ${currentTab === 2 ? s.menuBoxActive : ""}`}
              >
                <img src={Ressources} height={isMobile ? 45 : 65} style={{ marginRight: "10px" }} />
                Mes ressources
              </div>
              <div
                onClick={() => setCurrentTab(3)}
                className={`${s.menuBox} ${currentTab === 3 ? s.menuBoxActive : ""}`}
              >
                <img src={Dashboard} height={isMobile ? 35 : 50} style={{ marginRight: "10px" }} />
                Mes résultats
              </div>
            </div>
          )}

          {currentTab === 2 && (
            <div className={s.ressourcesBox}>
              <div className={s.header}>
                {/* FIX 2: Remove hardcoded width from inline style */}
                <Select
                  bordered={false}
                  loading={isLoading}
                  defaultValue={
                    localStorage.getItem("tempLevelId") || user?.levelId || defaultLevel
                  }
                  suffixIcon={
                    <Arrow
                      height={10}
                      className={s.iconArrowClass}
                      style={{ position: "relative", right: "0px", top: "0px" }}
                    />
                  }
                  placeholder="Selectionner un niveau"
                  className={s.__select}
                  onClick={() => setTempLevelId("")}
                  onChange={(id: string) => {
                    OnSelectLevel(id);
                    localStorage.setItem("tempLevelId", id);
                  }}
                >
                  {Object.keys(allLevels || {}).map((levelGroup) => (
                    <OptGroup key={levelGroup} label={levelGroup}>
                      {allLevels[levelGroup]?.map((level: any) => (
                        <Option key={level._id} value={level._id}>
                          {tempLevelId?.title || level.title}
                        </Option>
                      ))}
                    </OptGroup>
                  ))}
                </Select>
              </div>

              <div className={s.main}>
                {!loading ? (
                  tempTopic.length === 0 ? (
                    <AppResult
                      status="info"
                      title="Oups nous n'avons pas trouvé de matière !"
                    />
                  ) : (
                    <div className={s.row}>
                      {[...tempTopic]
                        .reverse()
                        .map((course: any) => (
                          <Link
                            key={course?._id}
                            to={`${appRoutes.STUDENT_CHAPTERS}/${course?._id}`}
                            className={s.__links}
                          >
                            <CardTracked
                              skillBarClassName={s.__skillbar}
                              name={course?.title}
                              id={course?._id}
                              progress={progress}
                              icon={getIcon(course?.description)}
                              widthImage={70}
                            />
                          </Link>
                        ))}
                    </div>
                  )
                ) : (
                  <div className={s.row}>
                    {[...Array(8)].map((_, i) => (
                      <CardTracked
                        key={i}
                        id=""
                        skillBarClassName={s.__skillbar}
                        widthImage={70}
                      />
                    ))}
                  </div>
                )}
              </div>
            </div>
          )}

          {currentTab === 3 && <Stats fromTabs={true} />}
        </div>
      </AppScreen>
    </React.Fragment>
  );
};

export default StudentDashboard;